import { render, staticRenderFns } from "./spt_data.vue?vue&type=template&id=47f691f1"
import script from "./spt_data.vue?vue&type=script&lang=js"
export * from "./spt_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports